module.exports = __webpack_public_path__ + "static/media/callgage-about-us-faded-logo.364e5bf7.png";